import { OrderStatus } from "@jti/magento";
import { useGetCustomerOrdersAllStoresQuery } from "@jti/store/slices/magentoApiSlice";

export enum CustomerType {
  purchaser = "purchaser",
  nonPurchaser = "nonPurchaser",
  unknown = "unknown",
}

const PURCHASER_STATUSES = new Set([
  OrderStatus.payment_completed,
  OrderStatus.shipped,
  OrderStatus.shipped_to_warehouse,
  OrderStatus.delivered,
  OrderStatus.delivered_to_pick_up_point,
]);

export const hasPurchaserStatus = (statuses: (string | null)[]): boolean =>
  statuses.some((s) => s !== null && PURCHASER_STATUSES.has(s));

export const useCustomerType = (isUserLoggedIn: boolean): CustomerType => {
  const { data, isLoading } = useGetCustomerOrdersAllStoresQuery(undefined, {
    skip: !isUserLoggedIn,
  });

  if (!isUserLoggedIn || isLoading) return CustomerType.unknown;

  const orderStatuses = data?.customer?.orders?.items.map((item) => item?.status ?? null) ?? [];

  return hasPurchaserStatus(orderStatuses) ? CustomerType.purchaser : CustomerType.nonPurchaser;
};
